// Spinner Loader
function runSpinnerLoader() {
  const spinner_loader = document.querySelector('.spinner-loader');
  if (spinner_loader) {
    spinner_loader.classList.remove('hidden');
    spinner_loader.classList.add('flex');
  }
}

function hideSpinnerLoader() {
  const spinner_loader = document.querySelector('.spinner-loader');
  if (spinner_loader) {
    spinner_loader.classList.add('hidden');
    spinner_loader.classList.remove('flex');
  }
}

// Skeleton Animation
function showSkeleton() {
  const skeleton = document.querySelector('.byteex-cart-drawer-items-skeleton');
  const cart_items_container = document.querySelector('.byteex-cart-drawer-items');

  if (skeleton && cart_items_container) {
    skeleton.classList.remove('hidden');
    cart_items_container.classList.add('hidden');
  }
}

function hideSkeleton() {
  const skeleton = document.querySelector('.byteex-cart-drawer-items-skeleton');
  const cart_items_container = document.querySelector('.byteex-cart-drawer-items');

  if (skeleton && cart_items_container) {
    skeleton.classList.add('hidden');
    cart_items_container.classList.remove('hidden');
  }
}

// Cart Color Picker Listeners
function addCartColorChangeListeners(index, type) {
  const color_picker_modal = document.querySelector(`.picker-modal-${index}`);
  const sorry_label = color_picker_modal.previousElementSibling;
  const selected_colors = color_picker_modal.querySelectorAll('.byteex-cart-selected-color');
  const remove_color_buttons = color_picker_modal.querySelectorAll('.byteex-cart-remove-color');
  const colors_variants = color_picker_modal.querySelectorAll('.byteex-cart-color-item');
  const submit_button = color_picker_modal.querySelector('.byteex-cart-picker-submit');
  const colors_filters = color_picker_modal.querySelectorAll('.byteex-cart-color-filter');

  function filterColors(event) {
    const filter_button = event.currentTarget;
    const filter_value = filter_button.dataset.value;

    colors_filters.forEach((filter) => {
      filter.style.fontWeight = '400';
    });
    filter_button.style.fontWeight = '700';

    colors_variants.forEach((variant) => {
      const variant_filters = variant.dataset.filter.toLowerCase();

      variant.style.display = 'flex';
      if (!variant_filters.includes(filter_value) && filter_value != 'All') {
        variant.style.display = 'none';
      }
    });
  }

  function removeColorHandler(event) {
    const button = event.currentTarget;
    button.style.display = 'none';
    const parent = button.parentElement;
    parent.dataset.empty = 'true';
    parent.dataset.id = 'empty';
    parent.dataset.image = 'empty';
    parent.dataset.color = 'empty';

    const image_element = parent.querySelector('img');
    if (image_element) {
      image_element.style.display = 'none';
    }

    const text_element = parent.nextElementSibling;
    if (text_element) {
      text_element.textContent = '';
    }

    const out_of_stock_label = parent.querySelector('.out-of-stock-label');
    if (out_of_stock_label) {
      out_of_stock_label.style.display = 'none';
    }
  }

  function selectColorHandler(event) {
    const button = event.currentTarget;
    const id = button.dataset.id;
    const image = button.dataset.image;
    const color = button.dataset.color;

    for (const color_variant of selected_colors) {
      const is_empty = color_variant.dataset.empty;

      if (is_empty === 'true') {
        color_variant.dataset.id = id;
        color_variant.dataset.image = image;
        color_variant.dataset.color = color;

        const remove_button = color_variant.querySelector('.byteex-cart-remove-color');
        if (remove_button) {
          remove_button.style.display = 'block';
        }

        const image_element = color_variant.querySelector('img');
        if (image_element) {
          image_element.src = image;
          image_element.style.display = 'block';
        }

        const out_of_stock_label = color_variant.querySelector('.out-of-stock-label');
        if (out_of_stock_label) {
          out_of_stock_label.style.display = 'none';
        }

        const text_element = color_variant.nextElementSibling;
        if (text_element) {
          text_element.textContent = color;
        }

        color_variant.dataset.empty = 'false';
        break;
      }
    }
  }

  async function submitHandler(event) {
    const button = event.currentTarget;
    const key = button.dataset.key;

    let is_all_selected = true;
    let changes = {
      id: key,
      properties: {}
    };

    let index = 1;
    for (const color_variant of selected_colors) {
      const is_empty = color_variant.dataset.empty;

      if (is_empty === 'true') {
        is_all_selected = false;
        break;
      }

      changes.properties[`_id${index}.`] = color_variant.dataset.id;
      changes.properties[`_${index}.`] = color_variant.dataset.image;
      changes.properties[`${type} ${index}`] = color_variant.dataset.color;

      index++;
    }

    if (is_all_selected) {
      const text = button.querySelector('.byteex-cart-picker-submit-text');
      const loader = button.querySelector('.loader');

      text.style.display = 'none';
      loader.style.display = 'block';

      try {
        await fetch(window.Shopify.routes.root + "cart/change.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(changes),
        });

        colors_filters.forEach((filter) => {
          filter.removeEventListener("click", filterColors);
        });

        remove_color_buttons.forEach((button) => {
          button.removeEventListener("click", removeColorHandler);
        });

        colors_variants.forEach((color_variant) => {
          color_variant.removeEventListener("click", selectColorHandler);
        });

        submit_button.removeEventListener("click", submitHandler);

        await updateCartDrawer();

      } catch (error) {
        console.error("Error:", error);
      }
    }
  }

  function sorryLabelCloseHandler(event) {
    const button = event.currentTarget;
    if (button) {
      button.style.display = 'none';
    }
  }

  colors_filters.forEach((filter) => {
    filter.addEventListener("click", filterColors);
  });

  remove_color_buttons.forEach((button) => {
    button.addEventListener("click", removeColorHandler);
  });

  colors_variants.forEach((color_variant) => {
    color_variant.addEventListener("click", selectColorHandler);
  });

  if (submit_button) {
    submit_button.addEventListener("click", submitHandler);
  }

  if (sorry_label) {
    sorry_label.addEventListener("click", sorryLabelCloseHandler);
  }

  const nailPicker = document.querySelector(`.picker-${index}`);
  const overlay = document.querySelector('.cart-overlay');
  overlay.addEventListener('click', () => {
    colors_filters.forEach((filter) => {
      filter.removeEventListener("click", filterColors);
    });

    remove_color_buttons.forEach((button) => {
      button.removeEventListener("click", removeColorHandler);
    });

    colors_variants.forEach((color_variant) => {
      color_variant.removeEventListener("click", selectColorHandler);
    });

    submit_button.removeEventListener("click", submitHandler);

    sorry_label.removeEventListener('click', sorryLabelCloseHandler);

    nailPicker.style.display = 'none';
    overlay.style.display = 'none';
  });
}

// Cart Drawer Listeners
function addCartDrawerListeners() {
  // Quantity Buttons
  document.querySelectorAll(".quantity-btn").forEach((button) => {
    button.addEventListener("click", async (event) => {
      event.preventDefault();

      runSpinnerLoader();
      showSkeleton();

      const parent = button.closest('.quantity-buttons-wrapper');
      const key = parent.closest('.cart-drawer-product-item').getAttribute("data-line-item-key");
      const quantityInput = parent.querySelector("input");

      const currentQuantity = quantityInput.value;
      const isUp = button.classList.contains("quantity-plus");
      const newQuantity = isUp ? +currentQuantity + 1 : +currentQuantity - 1;

      let updates = {
        [key]: newQuantity,
      };

      try {
        const response = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ updates }),
        });

        if (!response.ok) {
          console.error("Cart update failed:", response.status);
        }
      } catch (error) {
        console.error("Fetch error:", error);
      } finally {
        await updateCartDrawer();
      }
    });
  });

  // Close Cart Buttons
  document.querySelectorAll(".close_cart_btn").forEach((btn) => {
    btn.addEventListener("click", (event) => {
      event.preventDefault();

      if (cart_upsell_slider) {
        cart_upsell_slider.destroy();
        cart_upsell_slider = null;
      }

      document.documentElement.style.overflow = "unset";
      document.getElementById("byteex_cart_drawer").style.display = "none";
    });
  });

  // Checkout Button
  const checkout_button = document.getElementById('checkout_btn');
  if (checkout_button) {
    checkout_button.addEventListener('click', async (event) => {
      event.preventDefault();
      event.stopPropagation();

      const button = event.currentTarget;
      button.style.pointerEvents = "none";
      button.style.opacity = "0.5";

      await updateCartDrawer();

      runSpinnerLoader();
      showSkeleton();

      const updated_button = document.getElementById('checkout_btn');
      updated_button.style.pointerEvents = "none";
      updated_button.style.opacity = "0.5";

      const selected_colors = document.querySelectorAll('.byteex-cart-selected-color');
      let is_empty = false;
      let empty_index;
      let empty_type;
      selected_colors.forEach((color) => {
        const empty_status = color.dataset.empty;

        if (empty_status === 'true') {
          is_empty = true;
          empty_index = color.dataset.index;
          empty_type = color.dataset.type;
        }
      });

      if (is_empty) {
        hideSpinnerLoader();
        hideSkeleton();

        const nailPicker = document.querySelector(`.picker-${empty_index}`);

        const sorryLabel = nailPicker.querySelector('.sorry-label');
        if (sorryLabel) {
          sorryLabel.style.display = 'block';
        }

        const overlay = document.querySelector('.cart-overlay');
        nailPicker.style.display = 'block';
        overlay.style.display = 'block';

        addCartColorChangeListeners(empty_index, empty_type);
      } else {
        const dataGiftsElement = document.querySelector('.data-cart-gifts-ids');
        const giftsList = dataGiftsElement.dataset.cartGiftsIds;

        if (giftsList) {
          const giftsIds = giftsList.split(',').filter(id => id.trim() !== '');
          const threshold = dataGiftsElement.dataset.threshold;

          const updates = {};
          giftsIds.forEach(id => {
            updates[id] = (updates[id] || 0) + 1;
          });

          const items = Object.entries(updates).map(([id, qty]) => ({
            id,
            quantity: qty,
            properties: {
              Gift: '✓',
              _threshold: threshold
            }
          }));

          (async () => {
            try {
              const response = await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'Accept': 'application/json'
                },
                body: JSON.stringify({ items })
              });

              if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
              }

              window.location.href = "/checkout";
            } catch (error) {
              console.error('Error adding gifts to cart:', error);
            }
          })();
        } else {
          window.location.href = "/checkout";
        }
      }
    });
  }

  // Delete Product from Cart
  const remove_buttons = document.querySelectorAll('.remove-cart-item');
  remove_buttons.forEach(button => {
    button.addEventListener('click', async (event) => {
      showSkeleton();
      runSpinnerLoader();

      const button = event.currentTarget;
      const id = button.dataset.key;

      let updates = {
        [id]: 0,
      };

      try {
        const response = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ updates }),
        });

        if (!response.ok) {
          console.error(`Cart update failed: ${response.status}`);
        }
      } catch (error) {
        console.error("Fetch error:", error);
      } finally {
        await updateCartDrawer();
      }
    });
  });

  // Delete Gel Set Product from Cart
  const remove_gel_set_buttons = document.querySelectorAll('.remove-gel-wrap-set');
  remove_gel_set_buttons.forEach(button => {
    button.addEventListener('click', async (event) => {
      showSkeleton();
      runSpinnerLoader();

      const button = event.currentTarget;
      const boxIndex = button.dataset.key;
      const keys_array = [];
      let updates = {};

      fetch("/cart.js")
        .then((res) => res.json())
        .then((data) => {
          const cartItems = data.items;

          cartItems.forEach((item) => {
            if (+item.properties._dynamicBoxIndex === +boxIndex) {
              keys_array.push(item.key);
            }
          });

          keys_array.forEach(key => {
            updates[key] = 0;
          });

          fetch(`${window.Shopify.routes.root}cart/update.js`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ updates }),
          })
            .then((res) => res.json())
            .then(async (data) => {
              //console.log("✅ Successfully updated cart:", data);

              await updateCartDrawer();
              hideSpinnerLoader();
              hideSkeleton();
            })
            .catch((err) => console.error("❌ Error adding to cart:", err));
        })
        .catch((err) => console.error("❌ Error adding to cart:", err));
    });
  });

  // Open Pedicure Colors Picker Buttons
  const pedicure_colors_picker_open_button = document.querySelector('.pedicure-colors-picker-open-button');
  const pedicure_colors_picker = document.querySelector('.pedicure-colors-picker');
  let pedicure_colors_array = [];
  if (pedicure_colors_picker_open_button) {
    pedicure_colors_picker_open_button.addEventListener('click', () => {
      pedicure_colors_picker.classList.remove('hidden');

      (function () {
        const el = document.querySelector('.pedicure-color-list-slider-wrapper');
        if (!el) return;

        console.log('run slider');

        const bar = document.querySelector('.pedicure-color-list-scrollbar');
        const track = bar.querySelector('.track');
        const thumb = bar.querySelector('.thumb');

        let isDown = false;
        let startX = 0;
        let startScrollLeft = 0;

        let velocity = 0;
        let lastX = 0;
        let lastTime = 0;
        let rafId = 0;
        let momentumRunning = false;

        const stopMomentum = () => {
          momentumRunning = false;
          cancelAnimationFrame(rafId);
        };

        const momentum = () => {
          momentumRunning = true;

          if (Math.abs(velocity) < 0.01) {
            momentumRunning = false;
            return;
          }
          el.scrollLeft -= velocity * 12;
          velocity *= 0.95;

          updateThumb();
          rafId = requestAnimationFrame(momentum);
        };

        el.addEventListener('dragstart', (e) => e.preventDefault());

        el.addEventListener('mousedown', (e) => {
          if (e.button !== 0) return;
          isDown = true;
          el.classList.add('grabbing');

          bar.classList.add('active');

          startX = e.clientX;
          startScrollLeft = el.scrollLeft;
          velocity = 0;
          lastX = e.clientX;
          lastTime = Date.now();
          stopMomentum();
        });

        window.addEventListener('mousemove', (e) => {
          if (!isDown) return;
          e.preventDefault();
          const dx = e.clientX - startX;
          el.scrollLeft = startScrollLeft - dx;

          const now = Date.now();
          const dt = now - lastTime;
          if (dt > 0) velocity = (e.clientX - lastX) / dt;
          lastX = e.clientX;
          lastTime = now;

          updateThumb();
        }, { passive: false });

        const endDrag = () => {
          if (!isDown) return;
          isDown = false;
          el.classList.remove('grabbing');

          setTimeout(() => bar.classList.remove('active'), 120);

          if (Math.abs(velocity) > 0.08) momentum();
        };

        window.addEventListener('mouseup', endDrag);
        el.addEventListener('mouseleave', endDrag);

        function updateThumb() {
          const cw = el.clientWidth;
          const sw = el.scrollWidth;
          const sl = el.scrollLeft;

          if (sw <= cw) {
            thumb.style.width = '0px';
            thumb.style.transform = 'translateX(0)';
            return;
          }

          const trackW = track.clientWidth;
          const minThumb = 40;
          const thumbW = Math.max((cw / sw) * trackW, minThumb);
          const maxLeft = trackW - thumbW;
          const left = (sl / (sw - cw)) * maxLeft;

          thumb.style.width = thumbW + 'px';
          thumb.style.transform = `translateX(${left}px)`;
        }

        function syncBarWidth() {
          //const rect = el.getBoundingClientRect();
          //bar.style.width = rect.width + 'px';
          updateThumb();
        }

        el.addEventListener('scroll', () => {
          updateThumb();
        }, { passive: true });

        window.addEventListener('resize', syncBarWidth);

        if (typeof ResizeObserver !== 'undefined') {
          const ro = new ResizeObserver(() => syncBarWidth());
          ro.observe(el);
          ro.observe(track);
        } else {
          setTimeout(syncBarWidth, 60);
        }

        syncBarWidth();
        setTimeout(syncBarWidth, 250);
      })();
    });
  }

  function getPedicureColorItemCount(targetId) {
    return pedicure_colors_array.filter(id => id === targetId).length;
  }

  const pedicure_colors_picker_submit_button = document.querySelector('.pedicure-colors-picker-submit-button');

  // Add Pedicure Color Item Buttons
  const add_pedicure_color_items = document.querySelectorAll('.add-pedicure-color-item');
  add_pedicure_color_items.forEach(button => {
    button.addEventListener('click', (event) => {
      const button = event.currentTarget;
      const id = button.dataset.id;

      pedicure_colors_array.push(id);

      const current_quantity_wrapper = document.querySelector(`.quantity-pedicure-color-item-wrapper[data-id="${id}"]`);
      if (current_quantity_wrapper) {
        current_quantity_wrapper.classList.remove('hidden');
        current_quantity_wrapper.querySelector('.pedicure-color-item-count').textContent = getPedicureColorItemCount(id);
      }

      const current_image_wrapper = document.querySelector(`.pedicure-picker-color-image-wrapper[data-id="${id}"]`);
      if (current_image_wrapper) {
        current_image_wrapper.classList.add('selected-pedicure-color-item');
      }

      pedicure_colors_picker_submit_button.textContent = pedicure_colors_picker_submit_button.dataset.addText;
      pedicure_colors_picker_submit_button.removeAttribute('disabled');
    });
  });

  // Plus Pedicure Color Item Buttons
  const plus_pedicure_color_items = document.querySelectorAll('.plus-pedicure-color-item');
  plus_pedicure_color_items.forEach(button => {
    button.addEventListener('click', (event) => {
      const button = event.currentTarget;
      const id = button.dataset.id;

      pedicure_colors_array.push(id);

      const current_quantity_wrapper = document.querySelector(`.quantity-pedicure-color-item-wrapper[data-id="${id}"]`);
      if (current_quantity_wrapper) {
        current_quantity_wrapper.querySelector('.pedicure-color-item-count').textContent = getPedicureColorItemCount(id);
      }
    });
  });

  // Minus Pedicure Color Item Buttons
  const minus_pedicure_color_items = document.querySelectorAll('.minus-pedicure-color-item');
  minus_pedicure_color_items.forEach(button => {
    button.addEventListener('click', (event) => {
      const button = event.currentTarget;
      const id = button.dataset.id;

      const index = pedicure_colors_array.indexOf(id);
      if (index !== -1) {
        pedicure_colors_array.splice(index, 1);
      }

      const count = getPedicureColorItemCount(id);
      const current_quantity_wrapper = document.querySelector(`.quantity-pedicure-color-item-wrapper[data-id="${id}"]`);

      if (count <= 0) {
        current_quantity_wrapper.classList.add('hidden');
        current_quantity_wrapper.querySelector('.pedicure-color-item-count').textContent = 0;

        const current_image_wrapper = document.querySelector(`.pedicure-picker-color-image-wrapper[data-id="${id}"]`);
        if (current_image_wrapper) {
          current_image_wrapper.classList.remove('selected-pedicure-color-item');
        }
      } else {
        current_quantity_wrapper.querySelector('.pedicure-color-item-count').textContent = count;
      }

      if (pedicure_colors_array.length === 0) {
        pedicure_colors_picker_submit_button.textContent = pedicure_colors_picker_submit_button.dataset.chooseText;
        pedicure_colors_picker_submit_button.disabled = true;
      }
    });
  });

  // Pedicure Colors Picker Submit Button  
  if (pedicure_colors_picker_submit_button) {
    pedicure_colors_picker_submit_button.addEventListener('click', () => {
      if (pedicure_colors_array.length > 0) {
        runSpinnerLoader();

        const formData = {
          items: pedicure_colors_array.map(id => ({
            id: id,
            quantity: 1
          }))
        };

        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),
        })
          .then((response) => {
            updateCartDrawer();
            return response.json();
          })
          .catch((error) => {
            console.error('Error:', error);
          });
      }

      pedicure_colors_picker.classList.add('hidden');
    });
  }

  // Close Pedicure Colors Picker Buttons
  const pedicure_colors_picker_close_buttons = document.querySelectorAll('.pedicure-colors-picker-close-button');
  if (pedicure_colors_picker_close_buttons) {
    pedicure_colors_picker_close_buttons.forEach(button => {
      button.addEventListener('click', () => {
        pedicure_colors_picker.classList.add('hidden');
      });
    });
  }

  // Add to Cart from Upsell Slider Buttons (drawer only — avoid stacking listeners on PDP / nail-picker buttons on each cart refresh)
  const cart_drawer_root = document.getElementById('byteex_cart_drawer');
  const cart_upsell_atc_buttons = cart_drawer_root
    ? cart_drawer_root.querySelectorAll('.cart-upsell-atc-button')
    : [];
  cart_upsell_atc_buttons.forEach(button => {
    button.addEventListener('click', async (event) => {
      showSkeleton();
      runSpinnerLoader();

      const button = event.currentTarget;
      const id = button.dataset.id;

      event.preventDefault();

      let formData = {
        items: [
          {
            id: id,
            quantity: 1,
          },
        ],
      };

      try {
        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        });

        if (!response.ok) {
          console.error(`Cart add error: ${response.status}`);
        }

      } catch (error) {
        console.error("Fetch error:", error);
      } finally {
        await updateCartDrawer();
      }
    });
  });

  // Choose Colors Buttons
  const choose_colors_buttons = document.querySelectorAll('.cart-upsell-choose-colors-button');
  choose_colors_buttons.forEach(button => {
    button.addEventListener('click', (event) => {
      const button = event.currentTarget;
      const choose_colors_element = button.nextElementSibling;
      choose_colors_element.style.display = 'block';

      // Choose Colors Add Buttons
      let colors_array = [];
      const choose_colors_add_buttons = choose_colors_element.querySelectorAll('.cart-upsell-color-add');
      choose_colors_add_buttons.forEach(button => {
        button.addEventListener('click', (event) => {
          const button = event.currentTarget;
          const id = button.dataset.id;
          const is_added = button.dataset.added;

          if (is_added === 'false') {
            colors_array.push(id);
            button.style.backgroundColor = '#000000';
            button.style.color = '#fff';
            button.querySelector('.cart-upsell-color-add-text').classList.add('hidden');
            button.querySelector('.cart-upsell-color-added-text').classList.remove('hidden');
            button.dataset.added = 'true';
          } else {
            button.style.backgroundColor = '#ffffff';
            button.style.color = '#000000';
            button.querySelector('.cart-upsell-color-add-text').classList.remove('hidden');
            button.querySelector('.cart-upsell-color-added-text').classList.add('hidden');
            button.dataset.added = 'false';
            colors_array = colors_array.filter(color => color !== id);
          }
        });
      });

      // Choose Colors Submit Buttons
      const choose_colors_submit_buttons = choose_colors_element.querySelectorAll('.cart-upsell-choose-colors-submit-button');
      choose_colors_submit_buttons.forEach(button => {
        button.addEventListener('click', (event) => {
          const button = event.currentTarget;
          const block_id = button.dataset.blockId;

          if (colors_array.length > 0) {
            runSpinnerLoader();

            const formData = {
              items: colors_array.map(id => ({
                id: id,
                quantity: 1
              }))
            };

            fetch(window.Shopify.routes.root + 'cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify(formData),
            })
              .then((response) => {
                updateCartDrawer();
                return response.json();
              })
              .catch((error) => {
                console.error('Error:', error);
              });
          }

          choose_colors_element.style.display = 'none';
          const block_element = document.querySelector(`.${block_id}`);
          block_element.style.display = 'none';
        });
      });
    });
  });

  // Open Colors Change Buttons for Nail Picker
  const open_color_change_buttons = document.querySelectorAll('.open-color-change');
  open_color_change_buttons.forEach(button => {
    button.addEventListener('click', (event) => {
      const button = event.currentTarget;
      const index = button.dataset.index;
      const type = button.dataset.type;

      const nailPicker = document.querySelector(`.picker-${index}`);
      const overlay = document.querySelector('.cart-overlay');
      nailPicker.style.display = 'block';
      overlay.style.display = 'block';

      addCartColorChangeListeners(index, type);
    });
  });
}

// Update Cart Items Count in Header
async function updateCartItemCount() {
  const result = await fetch("/cart.js");
  const cart = await result.json();

  // Count only paid products (price not 0), excluding "Checkout" items
  const count = cart.items.reduce((sum, item) => {
    if (item.price === 0 || item.title.includes('Checkout')) {
      return sum;
    }
    return sum + item.quantity;
  }, 0);

  const items_count_element = document.querySelector('.cart_items_counter');

  if (items_count_element) {
    const items_count_element_wrapper = items_count_element.parentElement;

    if (count > 0) {
      items_count_element_wrapper.classList.remove('hidden');
      items_count_element_wrapper.classList.add('flex');
      items_count_element.textContent = count;
    } else {
      items_count_element_wrapper.classList.add('hidden');
      items_count_element_wrapper.classList.remove('flex');
    }
  }
}

// Update Cart Drawer
async function updateCartDrawer() {
  if (cart_upsell_slider) {
    cart_upsell_slider.destroy();
    cart_upsell_slider = null;
  }

  try {
    showSkeleton();
    runSpinnerLoader();

    const locale = Shopify?.locale;
    const localePrefix = locale && locale !== 'en' ? `/${locale}` : '';
    const res = await fetch(`${localePrefix}/?section=a-cart-drawer-v9`);

    if (!res.ok) throw new Error(`Cart loading error: ${res.status}`);

    const text = await res.text();
    const html = document.createElement("div");
    html.innerHTML = text;

    const newContentEl = html.querySelector(".byteex_cart_drawer");
    const currentDrawer = document.querySelector(".byteex_cart_drawer");

    if (newContentEl && currentDrawer) {
      currentDrawer.innerHTML = newContentEl.innerHTML;
      updateCartItemCount();
      addCartDrawerListeners();
    } else {
      console.warn("Could not find .byteex_cart_drawer in the new or current HTML");
    }
  } catch (error) {
    console.error("Error in updateCartDrawer:", error);
  } finally {
    hideSpinnerLoader();

    const slider_container = document.getElementById('keen-upsell-slider');
    if (slider_container) {
      cart_upsell_slider = new KeenSlider(
        "#keen-upsell-slider",
        {
          loop: false,
          slides: {
            spacing: 1,
            perView: 1,
          },
        },
        [cart_upsell_navigation]
      );
    }

    hideSkeleton();

    const cart_drawer_product_titles = document.querySelectorAll('.cart-drawer-product-title');
    cart_drawer_product_titles.forEach(title => {
      const title_text = title.querySelector('p');
      const title_blur = title.querySelector('div');
      const title_height = title_text.offsetHeight;

      if (title_height > 42) {
        title_blur.classList.remove('hidden');
      }
    });

    const cart_drawer_upsell_product_titles = document.querySelectorAll('.cart-drawer-upsell-product-title');
    cart_drawer_upsell_product_titles.forEach(title => {
      const title_text = title.querySelector('p');
      const title_blur = title.querySelector('div');
      const title_height = title_text.offsetHeight;

      if (title_height > 21) {
        title_blur.classList.remove('hidden');
      }
    });
  }
}

// Function to add event listeners to Add to Cart forms
function addToCartFormListeners() {
  const addToCartForms = document.querySelectorAll('form[action*="/cart/add"]');
  addToCartForms.forEach((form) => {
    // Remove existing listeners to avoid duplicates
    form.removeEventListener("submit", handleAddToCartSubmit);
    form.addEventListener("submit", handleAddToCartSubmit);
  });
}

// Handle Add to Cart form submission
async function handleAddToCartSubmit(event) {
  showSkeleton();
  runSpinnerLoader();

  event.preventDefault();
  const form = event.currentTarget
  const productType = form.dataset.productType;

  const loader = form.querySelector(".loader");
  const buttonText = form.querySelector(".atc_button_text");
  const priceAtc = form.querySelector(".price-atc");
  const priceAtcArrow = form.querySelector(".price-atc-arrow");
  const atc_button_text = document.getElementById('atc-button-text');

  const stickyLoader = document.getElementById("sticky_atc_button_loader");
  const stickyButtonText = document.getElementById("sticky_atc_button_text");

  if (atc_button_text) {
    atc_button_text.style.display = "none";
  }

  if (priceAtc) {
    priceAtc.style.display = "none";
  }

  if (priceAtcArrow) {
    priceAtcArrow.style.display = "none";
  }

  if (buttonText) {
    buttonText.style.display = "none";
  }

  if (loader) {
    loader.style.display = "block";
  }

  if (stickyButtonText) {
    stickyButtonText.style.display = "none";
  }

  if (stickyLoader) {
    stickyLoader.style.display = "block";
  }

  // Add to cart form
  const body = new FormData(form);

  const res = await fetch("/cart/add", {
    method: "post",
    body: body,
  })
    .then(async () => {
      // Removal the data on product pages
      if (productType === "at-home-nail-manicure-kit") {
        window.clearNailPicker();
      } else if (productType === "nail-picker-6-redesing") {
        window.clearNailPicker6Redesign();
      } else if (productType === "nail-picker-3-redesing") {
        window.clearNailPicker3Redesign();
      } else if (productType === "nail-picker-updated") {
        window.clearNailPickerUpdated();
      } else if (productType === "nail-picker-gel-wraps") {
        window.clearNailPickerGelWraps();
      } else if (productType === "new-nail-picker") {
        window.clearNewNailPicker();
      } else if (productType === "two-nail-picker-on-page") {
        window.clearTwoNailPickerOnPage();
      } else if (productType === "default") {
        if (atc_button_text) {
          atc_button_text.style.display = "flex";
        }
      }

      if (buttonText) {
        buttonText.style.display = "flex";
      }

      if (priceAtc) {
        priceAtc.style.display = "flex";
      }

      if (loader) {
        loader.style.display = "none";
      }

      if (stickyButtonText) {
        stickyButtonText.style.display = "inline";
      }

      if (stickyLoader) {
        stickyLoader.style.display = "none";
      }

      updateCartDrawer();

      if (
        !form.classList.contains("upsell_form") &&
        !form.classList.contains("addon_form") &&
        !form.classList.contains("pre-cart-form")
      ) {
        onOpenDrawer();
      }
    })
    .catch((error) => console.error("Error adding to cart:", error));
}

addToCartFormListeners();

// Update the cart counter on page load
// (delayed so it runs after section scripts that write the raw item_count)
setTimeout(() => {
  updateCartItemCount();
}, 3000);

// Refreshes the cart when the drawer is opened (called from onOpenDrawer)
// to display the real cart and not the one from the cache
window.refreshCartOnOpen = function () {
  runSpinnerLoader();
  showSkeleton();

  fetch('/cart.js', { cache: 'no-store' })
    .then(res => res.json())
    .then(cart => {
      const updates = {};

      cart.items.forEach(item => {
        if (item.original_price === 0 || item.title.includes('Checkout')) {
          updates[item.key] = 0;
        }
      });

      if (Object.keys(updates).length === 0) {
        return null;
      }

      return fetch(`${window.Shopify.routes.root}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates })
      }).then(r => {
        if (!r.ok) throw new Error('Error updating cart');
        return r.json();
      });
    })
    .then(async () => {
      await updateCartDrawer();
    })
    .catch(err => {
      console.error('Error processing cart:', err);
    });
};
